import React, { Component } from "react";
import {
  // Table,
  // TableHead,
  // TableRow,
  // TableBody,
  // TableCell,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import "./edsider/TheFilter/Components/FilterPapers.css";
import "./PaperMapping.css";
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import ContentWrapper from "../../../components/common/ContentWrapper";
import Card from "../../../components/common/Card";
import CardHeader from "../../../components/common/CardHeader";
import StickyCardBody from "../../../components/common/StickyCardBody";
import CardBody from "../../../components/common/CardBody";
import { AssessmentService } from "../../../service/candidate/assessmentService";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import { PaperService } from "../../../service/manage/paper/paper_service";
import { history } from "../../../helper/history";
import { Button, Dropdown } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { PAPER_FILTERS } from "../../../helper/constants";
import { CMC_PAPER_FILTERS } from "../../../helper/constants";
import { assessmentService } from "../../../service/assessment/assessmentService";
import PageSpinner from "../../../components/common/spinner/PageSpinner";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ReactSelect from "react-select";
import debounce from "lodash.debounce";
import { MarksheetService } from "../../../service/manage/mark_sheet/marksheet.service.js";
import moment from "moment";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Box, Chip, IconButton } from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "../../manage/paper/edsider/FindPaperTabs/PaperListChips.js";
import Tooltip from "@mui/material/Tooltip";
import ClearIcon from '@mui/icons-material/Clear';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import { HiArrowPath } from 'react-icons/hi2';
import sweetAlert from "../../../components/common/SweetAlert.js";
import { appConfigConstants } from '../../../helper/constants.js';
import SimpleReactValidator from "simple-react-validator";
import Spinner from "../../../components/common/Spinner";
import PaperFilterLayout from "./edsider/TheFilter/PaperFilterLayout.js";
import { EMPLOYEE_FILTERS } from '../../../helper/constants.js';
import { routes } from "../../../helper/routes.js";
import PaperOverrideDrawer from "./components/PaperOverrideDrawer.js";


const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const PAPER_DETAIL_STORAGE_KEY = "paper-mapping-detail-view";

const customer = getCustomerFeatureFlag();
let gradeText, isCMC, FILTERS, cancelClass, confirmClass;
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    isCMC = false;
    gradeText = "Grade";
    FILTERS = PAPER_FILTERS;
    cancelClass = "btn-default"
    confirmClass = "btn-primary"
    break;
  case customerConstants.EXO_CUSTOMER2:
    isCMC = true;
    gradeText = "Year";
    FILTERS = CMC_PAPER_FILTERS;
    cancelClass = "cmc-btn-default"
    confirmClass = "cmc-btn-primary"
    break;
  default:
    isCMC = false;
    gradeText = "Grade";
    FILTERS = PAPER_FILTERS;
    cancelClass = "btn-default"
    confirmClass = "btn-primary"
    break;
}

export default class PaperMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AssessmentList: [],
      selectedRows: new Set(),
      isLoading: true,
      node_mid: null,
      addedPapers: [],
      limit: 25,
      offset: 0,
      search_term: "",
      totalAssessments: 0,
      gradeCounts: [],
      subjectCounts: [],
      languageCounts: [],
      examCategoryCounts: [],
      sourceCounts: [],
      authorCounts: [],
      createdByCounts: [],
      categoryCounts: [],
      difficultyCounts: [],
      chapterCounts: [],
      yearCounts: [],
      termCounts: [],
      statusCounts: [],
      breadcrumb2: null,
      nodeTitle: null,
      currentPage: 0,
      sortColumn: "title",
      sortDirection: "desc",
      addVisibility: false,
      deleteVisibility: false,
      addingExamsLoading: false,
      deletingPapersLoading: false,
      deleteids: [],
      filterValues: [],
      filters: [],
      selectedFilters: [],
      selectedGrades: null,
      selectedChapters: null,
      selectedsubjects: null,
      selectedAuthors: null,
      selectedYears: null,
      selectedCategories: null,
      selectedExamCategories: null,
      selectedSources: null,
      selectedCreators: null,
      selectedStartDate: null,
      selectedEndDate: null,
      selectedTerms: null,
      selectedDifficulties: null,
      selectedLanguages: null,
      selectedStatuses: null,
      allCategories: [],
      allLanguages: [],
      allSubjects: [],
      allAuthors: [],
      allYears: [],
      allDifficulties: [],
      allGrades: [],
      allTerms: [],
      allChapters: [],
      allAssessmentStatuses: [],
      allExamCategories: [],
      allCreators: [],
      allTeachers: [],
      allAppConfigs: [],
      allCurrencyTypes: [],
      allCreditCategories: [],
      allSources: [],
      selectedTeacher: "",
      Teacherlist: [],
      selectedOption: "",
      isTeacherListLoading: false,
      isDataLoading: false,
      teacherSearchTerm: "",
      addPaper: false,
      deletePaper: false,
      selectedEditPaper: "",
      showOverrideModal: false,
      no_of_credits_error: "",
      price_error: "",
      paper_id: "",
      credit_purchase_flag: "",
      no_of_credits: "",
      override_credit: "",
      amount_purchase_flag: "",
      price: "",
      price_currency_type_id: 1,
      override_amount: "",
      assessment_id: "",
      disabled: false,
      valid_credit: true,
      valid_price: true,
    };
    this.validator = new SimpleReactValidator();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.debouncedHandleTeacherSearch = debounce(this.fetchAllTeachers, 1000);
  }

  componentDidMount() {
    sessionStorage.setItem('assessment-meta-data-load', 'true');
    sessionStorage.setItem("selectedTeacher", null);
    this.getAllAssessments();
    this.getPaperData();
    this.loadInitialData();
    this.fetchAllAssessmentSettings();
    this.fetchAllTeachers();
  }

  resetFormFields = () => {
    this.setState({
      no_of_credits_error: "",
      price_error: "",
      paper_id: "",
      credit_purchase_flag: "",
      no_of_credits: "",
      override_credit: "",
      amount_purchase_flag: "",
      price: "",
      price_currency_type_id: "",
      override_amount: "",
      assessment_id: "",
    });
  };

  fetchAllAssessmentSettings() {
    this.setState({
      isLoading: true,
    });

    const fetchAssessmentMetaData =
      assessmentService.getAllAssessmentMetaData();

    Promise.all([fetchAssessmentMetaData])
      .then((response) => {
        const [assessmentMetaDataResponse] = response;

        this.setState({
          allCategories: assessmentMetaDataResponse.data.find(
            (item) => "categories" in item
          ).categories,
          allLanguages: assessmentMetaDataResponse.data.find(
            (item) => "languages" in item
          ).languages,
          allSubjects: assessmentMetaDataResponse.data.find(
            (item) => "subjects" in item
          ).subjects,
          allAuthors: assessmentMetaDataResponse.data.find(
            (item) => "authors" in item
          ).authors,
          allYears: assessmentMetaDataResponse.data.find(
            (item) => "years" in item
          ).years,
          allDifficulties: assessmentMetaDataResponse.data.find(
            (item) => "difficulty_types" in item
          ).difficulty_types,
          allGrades: assessmentMetaDataResponse.data.find(
            (item) => "grades" in item
          ).grades,
          allTerms: assessmentMetaDataResponse.data.find(
            (item) => "terms" in item
          ).terms,
          allChapters: assessmentMetaDataResponse.data.find(
            (item) => "chapters" in item
          ).chapters,
          allAssessmentStatuses: assessmentMetaDataResponse.data.find(
            (item) => "statuses" in item
          ).statuses,
          allExamCategories: assessmentMetaDataResponse.data.find(
            (item) => "exam_categories" in item
          ).exam_categories,
          allCreators: assessmentMetaDataResponse.data.find(
            (item) => "creators" in item
          ).creators,
          allTeachers: assessmentMetaDataResponse.data.find(
            (item) => "teachers" in item
          ).teachers,
          allAppConfigs: assessmentMetaDataResponse.data.find(
            (item) => "app_configs" in item
          ).app_configs,
          allCurrencyTypes: assessmentMetaDataResponse.data.find(
            (item) => "currency_types" in item
          ).currency_types,
          allCreditCategories: assessmentMetaDataResponse.data.find(
            (item) => "credit_categories" in item
          ).credit_categories,
          allSources: assessmentMetaDataResponse.data.find(
            (item) => "sources" in item
          ).sources,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  }

  getCreditCategory(grade_id, subject_id, language_id, exam_category_id) {
    const creditCategory = this.state.allCreditCategories?.find(
      (creditCategory) =>
        creditCategory.grade_id == parseInt(grade_id)
        && creditCategory.subject_id == parseInt(subject_id)
        && creditCategory.language_id == parseInt(language_id)
        && creditCategory.exam_category_id == parseInt(exam_category_id)
    );
    if (creditCategory) {
      return true;
    }
    else {
      return false;
    }
  };

  getAppConfigValue(Name) {
    if (Name !== null) {
      const appConfig = this.state.allAppConfigs?.find(
        (appConfig) => appConfig.Name == Name && appConfig.Status === 1
      );
      return parseInt(appConfig?.Value);
    }
    else {
      return "N/A";
    }
  }

  getPaperCategory(category_id) {
    if (category_id !== null) {
      const category = this.state.allCategories?.find(
        (category) => category.category_id == category_id
      );
      return category?.name;
    }
    else {
      return "N/A";
    }
  }

  getPaperExamCategory(exam_category_id) {
    if (exam_category_id !== null) {
      const exam_category = this.state.allExamCategories?.find(
        (exam_category) => exam_category.exam_category_id == exam_category_id
      );
      return exam_category?.name;
    }
    else {
      return "N/A";
    }
  }

  getPaperSource(source_id) {
    if (source_id !== null) {
      const source = this.state.allSources?.find(
        (source) => source.source_id == parseInt(source_id)
      );
      return source?.source;
    }
    else {
      return "N/A";
    }
  }

  getPaperLanguage(language_id) {
    if (language_id !== null) {
      const language = this.state.allLanguages?.find(
        (language) => language.language_id == language_id
      );
      return language?.language;
    }
    else {
      return "N/A";
    }
  }

  getPaperSubject(subject_id) {
    if (subject_id !== null) {
      const subject = this.state.allSubjects?.find(
        (subject) => subject.subject_id == subject_id
      );
      return subject?.subject;
    }
    else {
      return "N/A";
    }
  }

  getPaperAuthor(author_id) {
    if (author_id !== null) {
      const author = this.state.allAuthors?.find(
        (author) => author.author_id == author_id
      );
      return author?.author;
    }
    else {
      return "N/A";
    }
  }

  getPaperYear(year_id) {
    if (year_id !== null) {
      const year = this.state.allYears?.find(
        (year) => year.year_id == year_id
      );
      return year?.year;
    }
    else {
      return "N/A";
    }
  }

  getPaperDifficulty(difficulty_id) {
    if (difficulty_id !== null) {
      const difficulty = this.state.allDifficulties?.find(
        (difficulty) => difficulty.difficulty_id == difficulty_id
      );
      return difficulty?.difficulty_type;
    }
    else {
      return "N/A";
    }
  }

  getPaperGrade(grade_id) {
    if (grade_id !== null) {
      const grade = this.state.allGrades?.find(
        (grade) => grade.grade_id == grade_id
      );
      return grade?.grade;
    }
    else {
      return "N/A";
    }
  }

  getPaperTerm(term_id) {
    if (term_id !== null) {
      const term = this.state.allTerms?.find(
        (term) => term.term_id == term_id
      );
      return term?.term;
    }
    else {
      return "N/A";
    }
  }

  getPaperChapter(chapter_id) {
    if (chapter_id !== null) {
      const chapter = this.state.allChapters?.find(
        (chapter) => chapter.chapter_id == chapter_id
      );
      return chapter?.chapter;
    }
    else {
      return "N/A";
    }
  }

  getPaperStatus(status_id) {
    if (status_id !== null) {
      const status = this.state.allAssessmentStatuses?.find(
        (status) => status.status_id == status_id
      );
      return status?.status;
    }
    else {
      return "N/A";
    }
  }

  getCreatedAtLocal(time) {
    if (time != null) {
      let timeStamp = new Date(time.concat("Z"))
      let d = new Date(timeStamp)
      // let startDate = d.toDateString();
      // let startTime = d.toLocaleTimeString('en-SL');
      let local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
      return local;
    }
    else {
      return "N/A";
    }
  }

  getColor(state) {
    switch (state) {
      case "Initial":
        return "label label-lg label-light-primary label-inline";
      case "Ready":
        return "label label-lg label-light-warning label-inline";
      case "Review":
        return "label label-lg label-light-default label-inline";
      case "Published":
        return "label label-lg label-success label-inline";
      case "Retired":
        return "label label-lg label-light-danger label-inline";
      case "InReview":
        return "label label-lg label-light-info label-inline";
      case "ReferBack":
        return "label label-lg label-light-danger label-inline";
      case "ReviewCompleted":
        return "label label-lg label-light-warning label-inline";
      default:
        return "label label-lg label-light-info label-inline";
    }
  }

  loadInitialData() {
    const {
      privilege_view,
      privilege_add,
      privilege_delete,
      breadcrumb2,
      nodeTitle,
    } = this.props.state;
    this.getVisibilityCheck(privilege_view, privilege_add, privilege_delete);
    this.setState({
      breadcrumb2: breadcrumb2,
      nodeTitle: nodeTitle,
    });
  }

  getVisibilityCheck(privilege_view, privilege_add, privilege_delete) {
    let addVisibility = false;
    let deleteVisibility = false;

    if (privilege_view === 1 && privilege_add === 1) {
      if (privilege_delete === 1) {
        addVisibility = true;
        deleteVisibility = true;
      } else {
        addVisibility = true;
      }
    } else if (privilege_view === 1 && privilege_add === null) {
      if (privilege_delete === 1) {
        addVisibility = true;
        deleteVisibility = true;
      } else {
        addVisibility = true;
      }
    }

    this.setState({
      addVisibility,
      deleteVisibility,
    });
  }

  async getPaperData() {
    try {
      const node_mid = this.props.state.mid;
      const paperData = await PaperService.getById(node_mid);
      this.setState({ paperData });

      if (paperData.data && paperData.data.length > 0) {
        const addedPapers = paperData.data.map((paper) => paper.assessment_id);
        this.setState({ addedPapers });
      }
    } catch (error) { }
  }

  getPaper(assessment_id) {
    if (assessment_id !== null) {
      const paper = this.state.paperData?.data?.find(
        (paper) => paper.assessment_id == parseInt(assessment_id)
      );
      return paper;
    }
    else {
      return "N/A";
    }
  }

  getCurrencyTypeSymbol(currency_type_id) {
    if (currency_type_id !== null) {
      const currency_type = this.state.allCurrencyTypes?.find(
        (currency_type) => currency_type.currency_type_id == parseInt(currency_type_id)
      );
      return currency_type?.symbol;
    }
    else {
      return "N/A";
    }
  }

  handleCheckboxChange = (assessment_id) => {
    this.setState((prevState) => {
      const selectedRows = new Set(prevState.selectedRows);

      if (selectedRows.has(assessment_id)) {
        selectedRows.delete(assessment_id);
        if (selectedRows.size <= 0) {
          this.setState({ addPaper: false, deletePaper: false });
        }
      } else {
        selectedRows.add(assessment_id);
        if (selectedRows.size > 0) {
          if (this.state.addedPapers.includes(assessment_id)) {
            this.setState({ addPaper: true });
          } else {
            if (selectedRows.size > 0) {
              if (!this.state.addPaper) {
                this.setState({ deletePaper: true });
              }
            }
          }
        }
      }

      return { selectedRows };
    });
  };

  handleAddAllExams = async (event) => {
    event.preventDefault();
    let lg_user_id = sessionStorage.getItem("manage_user_id");
    let lg_user_table_id = sessionStorage.getItem("table_log_id");

    this.setState({ addingExamsLoading: true });

    try {
      const node_mid = this.props.state.mid;

      const examList = [...this.state.selectedRows].map((assessment_id) => ({
        node_mid,
        create_user_id: lg_user_id,
        create_user_table_id: lg_user_table_id,
        assessment_id,
        assess_name: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).title,
        attempt_no: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).no_of_attempts,
        language_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).language_id,
        difficulty_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).difficulty_id,
        category_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).category_id,
        grade_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).grade_id,
        author_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).author_id,
        chapter_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).chapter_id,
        subject_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).subject_id,
        term_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).term_id,
        year_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).year_id,
        status_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).status_id,
        exam_category_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).exam_category_id,
        teacher_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).teacher_id,
      }));
      await PaperService.addAll(JSON.stringify(examList)).then((response) => {
        if (response.success) {
          this.setState({ addPaper: false, deletePaper: false });
          sweetStatusAlert("Success!", response.message.success, "success");
          this.getPaperData();
        } else {
          sweetStatusAlert("Failed!", response.message.error, "error");
        }
      });

      this.setState({ selectedRows: new Set() });
      this.setState({ addingExamsLoading: false });
    } catch (error) {
      this.setState({ addingExamsLoading: false });
    }
  };

  handleAddExams = async (event, assessment_id) => {
    event.preventDefault();

    const confirmResult = await window.Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to add this for available exams?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, add it!',
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
      cancelButtonText: 'Cancel',
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    let lg_user_id = sessionStorage.getItem("manage_user_id");
    let lg_user_table_id = sessionStorage.getItem("table_log_id");

    this.setState({ addingExamsLoading: true });

    try {
      const node_mid = this.props.state.mid;

      const examList = [{
        node_mid,
        create_user_id: lg_user_id,
        create_user_table_id: lg_user_table_id,
        assessment_id,
        assess_name: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).title,
        attempt_no: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).no_of_attempts,
        language_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).language_id,
        difficulty_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).difficulty_id,
        category_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).category_id,
        grade_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).grade_id,
        author_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).author_id,
        chapter_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).chapter_id,
        subject_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).subject_id,
        term_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).term_id,
        year_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).year_id,
        status_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).status_id,
        exam_category_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).exam_category_id,
        teacher_id: this.state.AssessmentList.find(
          (assessment) => assessment.assessment_id === assessment_id
        ).teacher_id,
      }];
      await PaperService.addAll(JSON.stringify(examList)).then((response) => {
        if (response.success) {
          this.setState({ addPaper: false, deletePaper: false });
          sweetStatusAlert("Success!", response.message.success, "success");
          this.getPaperData();
        } else {
          sweetStatusAlert("Failed!", response.message.error, "error");
        }
      });

      this.setState({ selectedRows: new Set() });
      this.setState({ addingExamsLoading: false });
    } catch (error) {
      this.setState({ addingExamsLoading: false });
    }
  };

  async deletePapers(paperIds, nodeMid) {
    this.setState({ deletingPapersLoading: true });
    try {
      const response = await PaperService.deleteAll(paperIds, nodeMid);

      if (response.success) {
        this.setState({ addPaper: false, deletePaper: false });
        sweetStatusAlert("Success!", response.message.success, "success");

        const updatedAddedPapers = this.state.addedPapers.filter(
          (paperId) => !paperIds.includes(paperId)
        );

        this.setState({
          selectedRows: new Set(),
          deletingPapersLoading: false,
          addedPapers: updatedAddedPapers,
        });
      } else {
        sweetStatusAlert("Failed!", response.message.error, "error");
        this.setState({ deletingPapersLoading: false });
      }
    } catch (error) {
      this.setState({ deletingPapersLoading: false });
    }
  }

  getAllAssessments() {
    const {
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedDifficulties,
      selectedGrades,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedsubjects,
      selectedStatuses,
      selectedExamCategories,
      selectedSources,
      selectedCreators,
      selectedStartDate,
      selectedEndDate,
    } = this.state;

    this.setState({ isLoading: true });

    AssessmentService.getfilterdAllAssesmentsWithPaginationAndSorting(
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedGrades,
      selectedDifficulties,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedsubjects,
      selectedStatuses,
      null,
      selectedExamCategories,
      selectedSources,
      selectedCreators,
      selectedStartDate,
      selectedEndDate,
    )
      .then((res) => {
        this.setState({
          AssessmentList: res.data.assessments,
          isLoading: false,
          totalAssessments: res.data.total_count,
          gradeCounts: res.data.grade_counts,
          subjectCounts: res.data.subject_counts,
          languageCounts: res.data.language_counts,
          examCategoryCounts: res.data.exam_category_counts,
          sourceCounts: res.data.source_counts,
          authorCounts: res.data.author_counts,
          categoryCounts: res.data.category_counts,
          difficultyCounts: res.data.difficulty_counts,
          chapterCounts: res.data.chapter_counts,
          yearCounts: res.data.year_counts,
          termCounts: res.data.term_counts,
          statusCounts: res.data.status_counts,
          createdByCounts: res.data.created_by_counts,
        });
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching Assessments. Please refresh the screen!",
          "error"
        );
        this.setState({ isLoading: false });
      });
  }

  handleViewClick = (e, paper) => {
    e.preventDefault();
    const detailPayload = this.buildPaperDetailPayload(paper);
    try {
      sessionStorage.setItem(PAPER_DETAIL_STORAGE_KEY, JSON.stringify(detailPayload));
    } catch (error) {
      // Ignore storage issues and continue with route state.
    }

    history.push({
      pathname: routes.paper_mapping_view.replace(":assessmentId", paper.assessment_id),
      state: {
        paperDetail: detailPayload,
      },
    });
  };

  handleEditClick = (e, paper) => {
    e.preventDefault();
    const editPaper = this.state.paperData.data?.find(
      (addedPaper) => addedPaper.assessment_id == paper.assessment_id
    );
    this.setState({
      selectedEditPaper: editPaper,
    }, () => {
      this.toggleOverRideCreditCategoryDetailModal(this.state.selectedEditPaper)
    });
  };

  toggleOverRideCreditCategoryDetailModal = (paper) => {
    this.setState((prevState) => ({
      showOverrideModal: !prevState.showOverrideModal,
      paper_id: paper?.id,
      credit_purchase_flag: paper?.credit_purchase_flag,
      no_of_credits: paper?.no_of_credits,
      override_credit: paper?.override_credit,
      amount_purchase_flag: paper?.amount_purchase_flag,
      price: paper?.amount,
      price_currency_type_id: paper?.amount_currency_type_id,
      override_amount: paper?.override_amount,
      assessment_id: paper?.assessment_id,
    }));
  };

  buildPaperDetailPayload = (paper) => {
    const mappedPaper = this.getPaper(paper?.assessment_id);
    const detailFields = [];

    const pushField = (label, value) => {
      if (value !== null && value !== undefined && value !== "") {
        detailFields.push({ label, value });
      }
    };

    pushField(gradeText, paper?.grade_id !== null ? this.getPaperGrade(paper?.grade_id) : null);
    pushField("Subject", paper?.subject_id !== null ? this.getPaperSubject(paper?.subject_id) : null);
    pushField("Language", paper?.language_id !== null ? this.getPaperLanguage(paper?.language_id) : null);
    pushField("Exam Category", paper?.exam_category_id !== null ? this.getPaperExamCategory(paper?.exam_category_id) : null);
    pushField("Author", paper?.author_id !== null ? this.getPaperAuthor(paper?.author_id) : null);
    pushField("Source", paper?.source_id !== null ? this.getPaperSource(paper?.source_id) : null);
    pushField("Difficulty", paper?.difficulty_id !== null ? this.getPaperDifficulty(paper?.difficulty_id) : null);
    pushField("Chapter/Module/Unit", paper?.chapter_id !== null ? this.getPaperChapter(paper?.chapter_id) : null);
    if (!isCMC) {
      pushField("Year", paper?.year_id !== null ? this.getPaperYear(paper?.year_id) : null);
    }
    pushField("Term/Semester", paper?.term_id !== null ? this.getPaperTerm(paper?.term_id) : null);

    if (this.state.addedPapers.includes(paper?.assessment_id)) {
      pushField("No of Credits", mappedPaper?.no_of_credits);
      if (mappedPaper?.amount_currency_type_id !== null && mappedPaper?.amount !== undefined) {
        pushField(
          "Amount",
          `${this.getCurrencyTypeSymbol(mappedPaper?.amount_currency_type_id)} ${mappedPaper?.amount}`
        );
      }
      pushField("Credit Purchase", mappedPaper?.credit_purchase_flag === 1 ? "Yes" : "No");
      pushField("Cash Purchase", mappedPaper?.amount_purchase_flag === 1 ? "Yes" : "No");
      pushField("Override Credit", mappedPaper?.override_credit === 1 ? "Yes" : "No");
      pushField("Override Amount", mappedPaper?.override_amount === 1 ? "Yes" : "No");
    }

    return {
      assessmentId: paper?.assessment_id,
      title: paper?.title || "Paper details",
      paperCode: "ASMNT" + paper?.assessment_id,
      assessmentState: paper?.assessment_state || "N/A",
      isAdded: this.state.addedPapers.includes(paper?.assessment_id),
      createdBy:
        paper?.first_name !== null && paper?.last_name !== null
          ? `${paper?.first_name} ${paper?.last_name}`
          : "N/A",
      createdAt: paper?.created_at ? this.getCreatedAtLocal(paper?.created_at) : "N/A",
      fields: detailFields,
    };
  };

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isLoading: true,
        currentPage: newPage,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  handleStartDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    this.setState({ selectedStartDate: formattedDate },
      () => {
        this.getAllAssessments();
      }
    )
  };

  handleEndDateChange = (event) => {
    const date = event.target.value;
    const formattedDate = date ? date.replace(/-/g, "") : null;
    this.setState({ selectedEndDate: formattedDate },
      () => {
        this.getAllAssessments();
      }
    )
  };


  clearDateRange = () => {
    this.setState({ selectedStartDate: "", selectedEndDate: "" },
      () => {
        this.setState({ selectedStartDate: null, selectedEndDate: null },
          () => {
            this.getAllAssessments();
          }
        );
      }
    );
  };

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          // isLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          // this.getAllAssessments();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  handleSortChange = (sortColumn) => {
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0,
        currentPage: 0,
        isLoading: true,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  handleSortSelect = (sortColumn) => {
    // When selecting from dropdown: toggle direction if same column,
    // otherwise default to 'asc' for Paper Code/Title and 'desc' for Status to match prior behavior
    const { sortColumn: currentSortColumn, sortDirection } = this.state;

    let newSortDirection;
    if (currentSortColumn === sortColumn) {
      newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      newSortDirection = (sortColumn === 'title' || sortColumn === 'assessment_id') ? 'asc' : 'desc';
    }

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0,
        currentPage: 0,
        isLoading: true,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  handleSetSortDirection = (direction) => {
    // Set sort direction while keeping current column
    const { sortDirection } = this.state;
    if (sortDirection === direction) return; // no-op when already set

    this.setState(
      {
        sortDirection: direction,
        offset: 0,
        currentPage: 0,
        isLoading: true,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  areAllAddedPapersSelected() {
    // Check if all "Added ✔" papers are selected
    return this.state.AssessmentList.every((assessment) =>
      this.state.addedPapers.includes(assessment.assessment_id)
    );
  }

  handleSelectAllAddedPapers() {
    // Select or deselect all "Added ✔" papers
    const selectedRows = new Set(this.state.selectedRows);
    if (this.areAllAddedPapersSelected()) {
      // Deselect all
      this.state.AssessmentList.filter((assessment) =>
        this.state.addedPapers.includes(assessment.assessment_id)
      ).forEach((assessment) => selectedRows.delete(assessment.assessment_id));
    } else {
      // Select all
      this.state.AssessmentList.filter((assessment) =>
        this.state.addedPapers.includes(assessment.assessment_id)
      ).forEach((assessment) => selectedRows.add(assessment.assessment_id));
    }

    this.setState({ selectedRows });
  }

  handleDelete = async () => {
    const selectedPaperIds = [...this.state.selectedRows];

    if (selectedPaperIds.length > 0) {
      // Check if all selected papers are marked as "Added ✔" before deleting
      const areAllSelectedAddedPapers = selectedPaperIds.every((paperId) =>
        this.state.addedPapers.includes(paperId)
      );

      if (areAllSelectedAddedPapers) {
        const nodeMid = this.props.state.mid;

        this.setState({ deletingPapersLoading: true });
        await PaperService.getPaper(nodeMid, selectedPaperIds).then((res) => {
          this.setState((prevState) => {
            const newDeleteIdsEnroll = res.data["paper_list"];
            const newDeleteIdsPapersa = res.data["papers"];

            const ar = [];
            const statusIds = [];
            if (!!newDeleteIdsEnroll.length) {
              newDeleteIdsPapersa.forEach((pa_paper) => {
                newDeleteIdsEnroll.forEach((en_paper) => {
                  if (pa_paper[0].assessment_id === en_paper[0].assessment_id) {
                    if (en_paper[0].paper_status === 1) {
                      statusIds.push(en_paper[0].assessment_id);
                      sweetStatusAlert(
                        "Can not remove the paper!",
                        "Paper has been already enrolled!",
                        "warning"
                      );
                      this.setState({
                        selectedRows: new Set(),
                      });
                    }
                  }
                  ar.push(pa_paper[0].assessment_id);
                });
              });
            } else {
              newDeleteIdsPapersa.forEach((pa_paper) => {
                ar.push(pa_paper[0].assessment_id);
              });
            }
            let uniqueArray = [...new Set(ar)];
            let uniqueStatusArray = [...new Set(statusIds)];
            const filteredArray = uniqueArray.filter(
              (item) => !uniqueStatusArray.includes(item)
            );
            if (!!filteredArray.length) {
              this.deletePapers(filteredArray, nodeMid);
            }
            this.setState({ deletingPapersLoading: false });
          });
        });
      } else {
        sweetStatusAlert(
          "Error!",
          "You can only delete papers that have been marked as 'Added ✔'.",
          "error"
        );
      }
    } else {
      sweetStatusAlert("Warning!", "Select papers to delete.", "warning");
    }
  }

  handleRemove = async (e, assessment_id) => {
    const confirmResult = await window.Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to remove this from available exams?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it!',
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
      cancelButtonText: 'Cancel',
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    const selectedPaperIds = [assessment_id];

    if (selectedPaperIds.length > 0) {
      // Check if all selected papers are marked as "Added ✔" before deleting
      const areAllSelectedAddedPapers = selectedPaperIds.every((paperId) =>
        this.state.addedPapers.includes(paperId)
      );

      if (areAllSelectedAddedPapers) {
        const nodeMid = this.props.state.mid;

        this.setState({ deletingPapersLoading: true });
        await PaperService.getPaper(nodeMid, selectedPaperIds).then((res) => {
          this.setState((prevState) => {
            const newDeleteIdsEnroll = res.data["paper_list"];
            const newDeleteIdsPapersa = res.data["papers"];

            const ar = [];
            const statusIds = [];
            if (!!newDeleteIdsEnroll.length) {
              newDeleteIdsPapersa.forEach((pa_paper) => {
                newDeleteIdsEnroll.forEach((en_paper) => {
                  if (pa_paper[0].assessment_id === en_paper[0].assessment_id) {
                    if (en_paper[0].paper_status === 1) {
                      statusIds.push(en_paper[0].assessment_id);
                      sweetStatusAlert(
                        "Can not remove the paper!",
                        "Paper has been already enrolled!",
                        "warning"
                      );
                      this.setState({
                        selectedRows: new Set(),
                      });
                    }
                  }
                  ar.push(pa_paper[0].assessment_id);
                });
              });
            } else {
              newDeleteIdsPapersa.forEach((pa_paper) => {
                ar.push(pa_paper[0].assessment_id);
              });
            }
            let uniqueArray = [...new Set(ar)];
            let uniqueStatusArray = [...new Set(statusIds)];
            const filteredArray = uniqueArray.filter(
              (item) => !uniqueStatusArray.includes(item)
            );
            if (!!filteredArray.length) {
              this.deletePapers(filteredArray, nodeMid);
            }
            this.setState({ deletingPapersLoading: false });
          });
        });
      } else {
        sweetStatusAlert(
          "Error!",
          "You can only delete papers that have been marked as 'Added ✔'.",
          "error"
        );
      }
    } else {
      sweetStatusAlert("Warning!", "Select papers to delete.", "warning");
    }
  }

  //New Multi Filter
  onSelectFilterMulti = (selectedItem) => {

    const { filterValues } = this.state;

    let updatedFilterValues = [...filterValues];

    const index = updatedFilterValues.findIndex(
      (item) =>
        item.filter === selectedItem.filter &&
        item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
    );


    if (index === -1) {

      updatedFilterValues.push(selectedItem);

    } else {

      updatedFilterValues.splice(index, 1);
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  onSelectFilterMultiProcess = (filterValues) => {

    const filterMap = {
      Category: [],
      Exam_Category: [],
      Difficulty: [],
      Language: [],
      Subject: [],
      Author: [],
      Year: [],
      Term: [],
      Chapter: [],
      Grade: [],
      Status: [],
      Created_By: [],
      Source: [],
    };

    filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
        switch (filterType) {
          case "Category":
            filterMap.Category.push(val?.category_id);
            break;
          case "Exam_Category":
            filterMap.Exam_Category.push(val?.exam_category_id);
            break;
          case "Difficulty":
            filterMap.Difficulty.push(val?.difficulty_id);
            break;
          case "Language":
            filterMap.Language.push(val?.language_id);
            break;
          case "Subject":
            filterMap.Subject.push(val?.subject_id);
            break;
          case "Author":
            filterMap.Author.push(val?.author_id);
            break;
          case "Year":
            filterMap.Year.push(val?.year_id);
            break;
          case "Term":
            filterMap.Term.push(val?.term_id);
            break;
          case "Chapter":
            filterMap.Chapter.push(val?.chapter_id);
            break;
          case "Grade":
            filterMap.Grade.push(val?.grade_id);
            break;
          case "Status":
            filterMap.Status.push(val?.status_id);
            break;
          case "Created_By":
            filterMap.Created_By.push(val?.created_by_id);
            break;
          case "Source":
            filterMap.Source.push(val?.source_id);
            break;
          default:
            break;
        }
      }
    });

    this.setState(
      {
        filterValues,
        selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
        selectedsubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
        selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
        selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
        selectedCategories:
          filterMap.Category.length > 0 ? filterMap.Category : null,
        selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
        selectedLanguages:
          filterMap.Language.length > 0 ? filterMap.Language : null,
        selectedDifficulties:
          filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
        selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null,
        selectedStatuses: filterMap.Status.length > 0 ? filterMap.Status : null,
        selectedExamCategories: filterMap.Exam_Category.length > 0 ? filterMap.Exam_Category : null,
        selectedSources: filterMap.Source.length > 0 ? filterMap.Source : null,
        selectedCreators: filterMap.Created_By.length > 0 ? filterMap.Created_By : null,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  isParentChecked = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    return (
      childItems.length > 0 &&
      childItems.every((child) =>
        filterValues.some(
          (selectedItem) =>
            selectedItem.filter === filterType &&
            selectedItem[`${filterType.toLowerCase()}_id`] ===
            child[`${filterType.toLowerCase()}_id`]
        )
      )
    );
  };

  isParentIndeterminate = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    const selectedCount = childItems.filter((child) =>
      filterValues.some(
        (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
          child[`${filterType.toLowerCase()}_id`]
      )
    ).length;
    return selectedCount > 0 && selectedCount < childItems.length;
  };

  handleParentCheckboxChange = (filterType, filterItems) => {
    const filterValues = [...this.state.filterValues];
    const childItems = filterItems

    const allSelected = this.isParentChecked(filterType);


    let updatedFilterValues;
    if (allSelected) {

      updatedFilterValues = filterValues.filter(
        (item) => item.filter !== filterType
      );
    } else {

      const newSelections = childItems.map((child) => ({
        filter: filterType,
        name: child.name,
        [`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
      }));
      updatedFilterValues = [
        ...filterValues.filter((item) => item.filter !== filterType),
        ...newSelections,
      ];
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  getChildItems = (filterType) => {
    switch (filterType) {
      case "Category":
        return this.state.allCategories || [];
      case "Exam_Category":
        return this.state.allExamCategories || [];
      case "Source":
        return this.state.allSources || [];
      case "Created_By":
        return this.state.allCreators || [];
      case "Difficulty":
        return this.state.allDifficulties || [];
      case "Language":
        return this.state.allLanguages || [];
      case "Subject":
        return this.state.allSubjects || [];
      case "Author":
        return this.state.allAuthors || [];
      case "Year":
        return this.state.allYears || [];
      case "Grade":
        return this.state.allGrades || [];
      case "Term":
        return this.state.allTerms || [];
      case "Chapter":
        return this.state.allChapters || [];
      case "Status":
        return this.state.allAssessmentStatuses || [];
      default:
        return [];
    }
  };

  clearAllFilters = () => {
    this.setState(
      {
        filterValues: [],
        selectedAuthors: null,
        selectedsubjects: null,
        selectedChapters: null,
        selectedTerms: null,
        selectedCategories: null,
        selectedYears: null,
        selectedLanguages: null,
        selectedDifficulties: null,
        selectedGrades: null,
        selectedStatuses: null,
        selectedExamCategories: null,
        selectedCreators: null,
        selectedSources: null,
      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  fetchAllTeachers = async () => {
    const { mid, form_list_id } = this.props.state;
    const lg_user_id = sessionStorage.getItem("manage_user_id");
    const lg_user_table_id = sessionStorage.getItem("table_log_id");
    this.setState({ isTeacherListLoading: true });
    await MarksheetService.getAllEnrolledStudents(
      mid,
      form_list_id,
      lg_user_id,
      lg_user_table_id,
      5000,
      0,
      "user_code",
      "desc",
      this.state.teacherSearchTerm
    )
      .then((response) => {
        if (response.success) {
          this.setState({ Teacherlist: response.data.users });
          this.setState({ isTeacherListLoading: false });
        } else {
          sweetStatusAlert("Failed!", response.message.error, "error");
          this.setState({ isTeacherListLoading: false });
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching teachers. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleTeacherSearch = (event) => {
    const regex = /^[a-zA-Z0-9\-@\[\]\s.&]*$/;
    if (event === "" || regex.test(event)) {
      let num = event;
      this.setState(
        {
          teacherSearchTerm: num,
          searchError: false,
        },
        () => {
          // Call the debounced version of fetchStudentData
          this.debouncedHandleTeacherSearch();
        }
      );
    } else {
      this.setState({ teacherSearchTerm: event, searchError: true });
    }
  };

  handleFilterChange = (newSelectedFilters) => {
    const getOrNull = (key) =>
      newSelectedFilters[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    this.setState(
      {
        selectedCategories: getOrNull("Category"),
        selectedAuthors: getOrNull("Author"),
        selectedChapters: getOrNull("Chapter"),
        selectedGrades: getOrNull("Grade"),
        selectedDifficulties: getOrNull("Difficulty"),
        selectedLanguages: getOrNull("Language"),
        selectedTerms: getOrNull("Term"),
        selectedYears: getOrNull("Year"),
        selectedsubjects: getOrNull("Subject"),
        selectedStatuses: getOrNull("Status"),
        selectedSources: getOrNull("Source"),
        selectedCreators: getOrNull("Created_By"),
        selectedExamCategories: getOrNull("Exam_Category"),
        selectedStartDate: getOrNull("StartDate"),
        selectedEndDate: getOrNull("EndDate"),

        offset: 0,
        currentPage: 0,

      },
      () => {
        this.getAllAssessments();
      }
    );
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    let { valid_credit, valid_price } = this.state;
    let error = '', price_error = '';

    if (name === "no_of_credits") {
      const noOfCreditsValue = parseInt(value);
      const minCredits = this.getAppConfigValue(appConfigConstants.MINIMUM_CREDIT_ASSESSMENT_LIMIT);
      const maxCredits = this.getAppConfigValue(appConfigConstants.MAXIMUM_CREDIT_ASSESSMENT_LIMIT);

      if (isNaN(noOfCreditsValue) || noOfCreditsValue < minCredits || noOfCreditsValue > maxCredits) {
        error = `No of credits must be between ${minCredits} and ${maxCredits}.`;
        valid_credit = false;
      } else {
        valid_credit = true;
      }
    }

    if (name === "price") {
      const priceValue = parseInt(value);
      const minPrice = this.getAppConfigValue(appConfigConstants.MINIMUM_PRICE_ASSESSMENT_LIMIT);
      const maxPrice = this.getAppConfigValue(appConfigConstants.MAXIMUM_PRICE_ASSESSMENT_LIMIT);

      if (isNaN(priceValue) || priceValue < minPrice || priceValue > maxPrice) {
        price_error = `Price must be between ${minPrice} and ${maxPrice}.`;
        valid_price = false;
      } else {
        valid_price = true;
      }
    }

    this.setState((prevState) => ({
      [name]: value,
      isModified: true,
      no_of_credits_error: name === "no_of_credits" ? error : prevState.no_of_credits_error,
      price_error: name === "price" ? price_error : prevState.price_error,
      valid_credit,
      valid_price,
      disabled: !(valid_credit && valid_price)
    }));
  };

  handleChangeCurrencyType = (event) => {
    event.preventDefault();
    this.setState({ price_currency_type_id: event.target.value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const confirmResult = await window.Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to save the changes?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, save it!',
      customClass: {
        confirmButton: `btn font-weight-bold ${confirmClass}`,
      },
      cancelButtonText: 'Cancel',
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    }
    else {
      this.setState({ showOverrideModal: false, isDataLoading: true });
      const paperItem = {
        id: parseInt(this.state.paper_id),
        credit_purchase_flag: this.state.credit_purchase_flag,
        no_of_credits: this.state.credit_purchase_flag === 0 ? "0" : this.state.no_of_credits,
        override_credit: this.state.override_credit,
        amount_purchase_flag: this.state.amount_purchase_flag,
        amount: this.state.amount_purchase_flag === 0 ? "0.0" : this.state.price,
        amount_currency_type_id: this.state.price_currency_type_id !== null ? this.state.price_currency_type_id : 1,
        override_amount: this.state.override_amount,
        assessment_id: parseInt(this.state.assessment_id),
      };

      PaperService.updateDetails(paperItem)
        .then((response) => {
          if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success").then(() => {
              this.getPaperData();
              this.getAllAssessments();
            });
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.setState({ isDataLoading: false });
          } else {
            this.setState({ isDataLoading: false });
            sweetStatusAlert("Failed!", response.message.error, "error");
          }
        })
        .catch((err) => {
          this.setState({ isDataLoading: false });
          sweetStatusAlert("Failed!", "Unable to override credit/amount", "error");
        });
    }
  };

  handleSync = () => {
    this.setState({ isDataLoading: true });
    PaperService.syncDetails()
      .then((response) => {
        if (response.success) {
          sweetStatusAlert("Success!", response.message.success, "success").then(() => {
            this.getPaperData();
            this.getAllAssessments();
          });
          this.setState({ isDataLoading: false });
        } else {
          this.setState({ isDataLoading: false });
          sweetStatusAlert("Failed!", response.message.error, "error");
        }
      })
      .catch((err) => {
        this.setState({ isDataLoading: false });
        sweetStatusAlert("Failed!", "Unable to sync changes", "error");
      });
  }

  getStatusVariant(status) {
    if (!status) return 'ph-status-default';
    const s = String(status).toLowerCase();
    // specific checks first
    if (s.includes('published')) return 'ph-status-published';
    if (s.includes('reviewcompleted') || s.includes('review completed') || s.includes('reviewcompleted')) return 'ph-status-reviewcompleted';
    if (s.includes('referback') || s.includes('refer back')) return 'ph-status-referback';
    if (s.includes('review') && !s.includes('reviewcompleted')) return 'ph-status-review';
    if (s.includes('enroll') || s.includes('enrolled')) return 'ph-status-enrolled';
    if (s.includes('purchase') || s.includes('paid')) return 'ph-status-purchase';
    return 'ph-status-default';
  }

  render() {
    const {
      AssessmentList,
      addedPapers,
      currentPage,
      totalAssessments,
      gradeCounts,
      subjectCounts,
      languageCounts,
      examCategoryCounts,
      sourceCounts,
      authorCounts,
      categoryCounts,
      difficultyCounts,
      chapterCounts,
      yearCounts,
      termCounts,
      statusCounts,
      createdByCounts,
      limit,
      addVisibility,
      deleteVisibility,
      addingExamsLoading,
      deletingPapersLoading,
      Teacherlist,
      isTeacherListLoading,
      offset,
      addPaper,
      deletePaper,
      selectedTeacher
    } = this.state;
    const path = history.location.pathname;

    return (
      <>
        <div>
          <ContentWrapper disabled={path === "/manage-search"}>
            {this.state.isDataLoading && (
              <Spinner id="show" text="Please wait.." />
            )}


            <>
              {/* <CardHeader>
                <div className="col-md-12 px-0 d-flex justify-content-between">
                  <div className="row d-flex" style={{ width: "100%" }}>
                    <div className="col-md-2 col-12 d-flex align-items-center px-0">
                       <div className="w-100 mr-1 py-1">
                        <ReactSelect
                          placeholder="Select Creator"
                          styles={{
                            menuPortal: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          options={Teacherlist.map((teacher) => ({
                            value: teacher.user_id,
                            label: `${teacher.data_concat}`,
                          }))}
                          value={this.state.selectedOption}
                          isLoading={isTeacherListLoading}
                          onChange={(selectedOption) => {
                            const selectedValue = selectedOption?.value;

                            if (!selectedValue) {
                              this.setState({
                                selectedTeacher: "",
                                selectedOption: "",
                              });
                              sessionStorage.setItem("selectedTeacher", null);
                              this.getAllAssessments();
                            }
                            let teacher = this.state.Teacherlist.find(
                              (teacher) => teacher.user_id === selectedValue
                            );

                            this.setState({
                              isTableDataLoading: true,
                              selectedOption: selectedOption,
                            });

                            if (teacher) {
                              const selectedTeacher = teacher.user_id;
                              if (selectedTeacher) {
                                this.setState({ selectedTeacher }, () => {
                                  sessionStorage.setItem("selectedTeacher", selectedTeacher);
                                  this.getAllAssessments();
                                });
                              }
                            }
                          }}
                          onInputChange={(inputValue) => {
                            if (inputValue) {
                              this.handleTeacherSearch(inputValue);
                            }
                          }}
                          isClearable={true}
                        />
                      </div> 
                    </div>
                      <>
                        <div className="row mt-5 align-items-center">
                          <div className="col-md-5 px-0 filterBySec">
                            <Accordion className="filterAccordion">
                              <AccordionSummary className="filterAccordionSummary" aria-controls="panel1-content" id="panel1-header">
                                <Box
                                  sx={{ display: "flex", alignItems: "center", gap: "16px" }}
                                >
                                  <div className="filterpprs mr-5">
                                    <TuneRoundedIcon />
                                    &emsp;Filter&emsp;
                                    <KeyboardArrowDownIcon
                                      sx={{
                                        transition: "transform 0.3s ease",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => { }}
                                    />
                                  </div>
                                </Box>
                              </AccordionSummary>
                              <div className="d-flex align-items-center ml-5 mt-2">
                                <div>
                                  Start Date&nbsp;:&nbsp;{" "}
                                  <input
                                    type="date"
                                    value={this.state.selectedStartDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
                                    onChange={this.handleStartDateChange}
                                    style={{ padding: "5px", marginRight: "10px", borderRadius: "4px" }}
                                  />

                                </div>

                                <div className='mr-2'>
                                  End Date&nbsp;:&nbsp;{" "}
                                  <input
                                    type="date"
                                    value={this.state.selectedEndDate?.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")}
                                    onChange={this.handleEndDateChange}
                                    style={{ padding: "5px", borderRadius: "4px" }}
                                  />

                                </div>

                                <Tooltip title="Clear dates">
                                  <IconButton onClick={() => this.clearDateRange()}>
                                    <DeleteForeverRoundedIcon />
                                  </IconButton>
                                </Tooltip>

                                <span class="badge badge-custom" style={{ fontSize: '1rem' }}>
                                  No of Papers:{" "}
                                  <strong>
                                    {this.state.isLoading ?
                                      (
                                        <CircularProgress size={16} />
                                      ) : (
                                        this.state.totalAssessments
                                      )
                                    }
                                  </strong>
                                </span>
                              </div>
                              <Box className="filterCardContainer" sx={{ display: "flex", flexWrap: "wrap", padding: "8px", whiteSpace: "normal" }}>

                                {FILTERS.filter((category) => {

                                  return ["Created_By", "Grade", "Subject", "Language", "Chapter", "Year", "Term", "Exam_Category", "Author", "Source", "Difficulty", "Status"].includes(category);

                                }).map((category, index) => {

                                  let filterItems = [];
                                  if (category === "Category") {
                                    const categoryCountsMap = new Map(categoryCounts.map(([category_id, count]) => [category_id, count]));
                                    filterItems = this.state.allCategories?.map((val) => ({
                                      filter: "Category",
                                      name: val.name,
                                      category_id: val.category_id,
                                      dynamic_count: categoryCountsMap.get(val.category_id) || 0,
                                    }));
                                  } else if (category === "Exam_Category") {
                                    const examCategoryCountsMap = new Map(examCategoryCounts.map(([exam_category_id, count]) => [exam_category_id, count]));
                                    filterItems = this.state.allExamCategories?.map((val) => ({
                                      filter: "Exam_Category",
                                      name: val.name,
                                      exam_category_id: val.exam_category_id,
                                      dynamic_count: examCategoryCountsMap.get(val.exam_category_id) || 0,
                                    }));
                                  } else if (category === "Difficulty") {
                                    const difficultyCountsMap = new Map(difficultyCounts.map(([difficulty_id, count]) => [difficulty_id, count]));
                                    filterItems = this.state.allDifficulties?.map((val) => ({
                                      filter: "Difficulty",
                                      name: val.difficulty_type,
                                      difficulty_id: val.difficulty_id,
                                      dynamic_count: difficultyCountsMap.get(val.difficulty_id) || 0,
                                    }));
                                  } else if (category === "Language") {
                                    const languageCountsMap = new Map(languageCounts.map(([language_id, count]) => [language_id, count]));
                                    filterItems = this.state.allLanguages?.map((val) => ({
                                      filter: "Language",
                                      name: val.language,
                                      language_id: val.language_id,
                                      dynamic_count: languageCountsMap.get(val.language_id) || 0,
                                    }));
                                  } else if (category === "Subject") {
                                    const subjectCountsMap = new Map(subjectCounts.map(([subject_id, count]) => [subject_id, count]));
                                    filterItems = this.state.allSubjects?.map((val) => ({
                                      filter: "Subject",
                                      name: val.subject,
                                      subject_id: val.subject_id,
                                      dynamic_count: subjectCountsMap.get(val.subject_id) || 0,
                                    }));
                                  } else if (category === "Author") {
                                    const authorCountsMap = new Map(authorCounts.map(([author_id, count]) => [author_id, count]));
                                    filterItems = this.state.allAuthors?.map((val) => ({
                                      filter: "Author",
                                      name: val.author,
                                      author_id: val.author_id,
                                      dynamic_count: authorCountsMap.get(val.author_id) || 0,
                                    }));
                                  } else if (category === "Year") {
                                    const yearCountsMap = new Map(yearCounts.map(([year_id, count]) => [year_id, count]));
                                    filterItems = this.state.allYears?.map((val) => ({
                                      filter: "Year",
                                      name: val.year,
                                      year_id: val.year_id,
                                      dynamic_count: yearCountsMap.get(val.year_id) || 0,
                                    }));
                                  } else if (category === "Grade") {
                                    const gradeCountsMap = new Map(gradeCounts.map(([grade_id, count]) => [grade_id, count]));
                                    filterItems = this.state.allGrades?.map((val) => ({
                                      filter: "Grade",
                                      name: val.grade,
                                      grade_id: val.grade_id,
                                      dynamic_count: gradeCountsMap.get(val.grade_id) || 0,
                                    }));
                                  } else if (category === "Term") {
                                    const termCountsMap = new Map(termCounts.map(([term_id, count]) => [term_id, count]));
                                    filterItems = this.state.allTerms?.map((val) => ({
                                      filter: "Term",
                                      name: val.term,
                                      term_id: val.term_id,
                                      dynamic_count: termCountsMap.get(val.term_id) || 0,
                                    }));
                                  } else if (category === "Chapter") {
                                    const chapterCountsMap = new Map(chapterCounts.map(([chapter_id, count]) => [chapter_id, count]));
                                    filterItems = this.state.allChapters?.map((val) => ({
                                      filter: "Chapter",
                                      name: val.chapter,
                                      chapter_id: val.chapter_id,
                                      dynamic_count: chapterCountsMap.get(val.chapter_id) || 0,
                                    }));
                                  } else if (category === "Status") {
                                    const statusCountsMap = new Map(statusCounts.map(([status_id, count]) => [status_id, count]));
                                    filterItems = this.state.allAssessmentStatuses?.map((val) => ({
                                      filter: "Status",
                                      name: val.status,
                                      status_id: val.status_id,
                                      dynamic_count: statusCountsMap.get(val.status_id) || 0,
                                    }));
                                  } else if (category === "Source") {
                                    const sourceCountsMap = new Map(sourceCounts.map(([source_id, count]) => [source_id, count]));
                                    filterItems = this.state.allSources?.map((val) => ({
                                      filter: "Source",
                                      name: val.source,
                                      source_id: val.source_id,
                                      dynamic_count: sourceCountsMap.get(val.source_id) || 0,
                                    }));
                                  } else if (category === "Created_By") {
                                    const createdByCountsMap = new Map(createdByCounts.map(([created_by_id, count]) => [created_by_id, count]));
                                    filterItems = this.state.allCreators?.map((val) => ({
                                      filter: "Created_By",
                                      name: val.first_name + " " + val.last_name,
                                      created_by_id: val.created_by_id,
                                      dynamic_count: createdByCountsMap.get(parseInt(val.created_by_id)) || 0,
                                    }));
                                  }

                                  return (
                                    <div className="filterCard" key={index} style={{ display: "inline-block", minWidth: "300px", marginRight: "16px", maxHeight: "30vh" }}>
                                      <FormControlLabel
                                        label={category}

                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "flex-start",
                                          "& .MuiFormControlLabel-label": { fontWeight: "600" },
                                        }}
                                        control={
                                          <Checkbox
                                            checked={this.isParentChecked(category)}
                                            indeterminate={this.isParentIndeterminate(category)}
                                            onChange={() => this.handleParentCheckboxChange(category, filterItems)}
                                          />
                                        }
                                      />
<Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>

                                        {filterItems?.map((item) => {

                                          const isChecked = this.state.filterValues.some((selectedItem) =>
                                            selectedItem.filter === item.filter &&
                                            selectedItem[`${item.filter.toLowerCase()}_id`] === item[`${item.filter.toLowerCase()}_id`]
                                          );

                                          return (
                                            <FormControlLabel
                                              key={item[`${category.toLowerCase()}_id`]}
                                              //label={`${item.name} ${` (${item.dynamic_count })`}`}
                                              label={`${item.name} ${item.dynamic_count !== 0 ? ` (${item.dynamic_count})` : ""}`}
                                              //disabled={item.dynamic_count === 0 || this.state.isTableDataLoading}
                                              control={
                                                <Checkbox
                                                  checked={isChecked}
                                                  onChange={() => this.onSelectFilterMulti(item)}
                                                />
                                              }
                                            />
                                          )
                                        })}
                                      </Box>
                                    </div>
                                  );
                                })}
                              </Box>
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-12 mt-5">
                          {this.state.filterValues && this.state.filterValues.length > 0 &&
                            <PaperListChips
                              filterValues={this.state.filterValues}
                              chipClick={this.onSelectFilterMulti}
                              clearAll={this.clearAllFilters}
                            />
                          }
                        </div>
                      </>
                  </div>
                </div>
              </CardHeader> */}

            </>

            <Card>
              <CardBody>
                <div className="thepapers-wrapper">
                  <div className="col-md-12 px-0">
                    <div className="row mt-6">
                      <div className="col-md-12 px-0">
                        <StickyCardBody>
                          <div className="row align-items-center mb-2">
                            <div className="col-12">
                              <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2">

                                <div className="left-controls" style={{ minWidth: 0 }}>
                                  <div className="left-controls-mother d-flex align-items-center" style={{ width: '100%', gap: '24px' }}>
                                    <div className="search-chips" style={{ minWidth: 240, flex: '1 1 240px' }}>
                                      <Form.Group controlId="exampleForm.ControlInput1" className="mb-0 h-100">
                                        <Form.Control
                                          type="text"
                                          placeholder="Search"
                                          onChange={this.handleSearch}
                                          isInvalid={this.state.searchError}
                                          className="w-100"
                                        />
                                        {this.state.searchError && (
                                          <Form.Control.Feedback type="invalid">
                                            Invalid input
                                          </Form.Control.Feedback>
                                        )}
                                      </Form.Group>
                                    </div>

                                    <div className="papers-count-wrapper d-flex align-items-center">
                                      <div className="sort-button no-of-papers" style={{ fontSize: '0.9rem', fontFamily: 'Inter, sans-serif' }}>
                                        <span className="sort-by-label">Number of Papers</span>
                                        <span className="sort-current" style={{ marginLeft: '8px', marginRight: '8px', fontWeight: 600, color: '#e49424', fontFamily: 'Inter, sans-serif' }}>
                                          {this.state.isLoading ? (
                                            <CircularProgress size={16} />
                                          ) : (
                                            this.state.totalAssessments
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center gap-2 right-controls mt-2">


                                  <Dropdown className="sort-dropdown">
                                    <Dropdown.Toggle
                                      variant="light"
                                      id="sort-dropdown"
                                      className={`sort-button ${this.state.sortDirection === 'desc' ? 'desc' : ''}`}
                                    >
                                      <span className="sort-by-label">
                                        Sort By:
                                      </span>
                                      <span className="sort-current">
                                        {this.state.sortColumn === "assessment_id" && "Paper Code"}
                                        {this.state.sortColumn === "title" && "Paper Title"}
                                        {this.state.sortColumn === "assessment_state" && "Status"}
                                      </span>
                                      {this.state.sortDirection === 'asc' ? (
                                        <ArrowUpwardIcon sx={{ fontSize: 16, color: '#5458AF', marginLeft: '4px' }} />
                                      ) : (
                                        <ArrowDownwardIcon sx={{ fontSize: 16, color: '#5458AF', marginLeft: '4px' }} />
                                      )}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="sort-menu">
                                      <div className="menu-header">
                                        Sort By
                                      </div>

                                      <div className="menu-body">
                                        <Dropdown.Item
                                          active={this.state.sortColumn === "assessment_id"}
                                          onClick={() => this.handleSortSelect("assessment_id")}
                                        >
                                          Paper Code
                                          {this.state.sortColumn === "assessment_id" && <span className="checkmark">✓</span>}
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          active={this.state.sortColumn === "title"}
                                          onClick={() => this.handleSortSelect("title")}
                                        >
                                          Paper Title
                                          {this.state.sortColumn === "title" && <span className="checkmark">✓</span>}
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          active={this.state.sortColumn === "assessment_state"}
                                          onClick={() => this.handleSortSelect("assessment_state")}
                                        >
                                          Status
                                          {this.state.sortColumn === "assessment_state" && <span className="checkmark">✓</span>}
                                        </Dropdown.Item>
                                      </div>

                                      <Dropdown.Divider />

                                      <div className="direction-header">
                                        Order
                                      </div>

                                      <Dropdown.Item
                                        className="direction-item"
                                        active={this.state.sortDirection === 'asc'}
                                        onClick={() => this.handleSetSortDirection('asc')}
                                      >
                                        <ArrowUpwardIcon sx={{ fontSize: 18, marginRight: '8px' }} />
                                        <span className="direction-label">Ascending</span>
                                        {this.state.sortDirection === 'asc' && <span className="checkmark">✓</span>}
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        className="direction-item"
                                        active={this.state.sortDirection === 'desc'}
                                        onClick={() => this.handleSetSortDirection('desc')}
                                      >
                                        <ArrowDownwardIcon sx={{ fontSize: 18, marginRight: '8px' }} />
                                        <span className="direction-label">Descending</span>
                                        {this.state.sortDirection === 'desc' && <span className="checkmark">✓</span>}
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>

                                  {addVisibility && this.state.selectedRows.size > 0 && deletePaper && (
                                    <Button
                                      className="insert-btn btn-primary text-nowrap"
                                      variant="contained"
                                      onClick={this.handleAddAllExams}
                                      style={{ height: "44px" }}
                                    >
                                      {addingExamsLoading ? (
                                        <CircularProgress size={20} color="inherit" />
                                      ) : (
                                        "Add Selected Papers"
                                      )}
                                    </Button>
                                  )}

                                  {deleteVisibility && this.state.selectedRows.size > 0 && addPaper && (
                                    <Button
                                      className="insert-btn btn-danger text-nowrap"
                                      variant="contained"
                                      onClick={() => this.handleDelete()}
                                      style={{ height: "44px" }}
                                    >
                                      {deletingPapersLoading ? (
                                        <CircularProgress size={20} color="inherit" />
                                      ) : (
                                        "Remove Selected Papers"
                                      )}
                                    </Button>
                                  )}

                                  {/* <button
                                    className="sync-button"
                                    onClick={() => this.handleSync()}
                                    style={{
                                      background: 'none',
                                      border: 'none',
                                      padding: 0,
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                    title="Sync Credit Categories Changes"
                                    aria-label="Sync Credit Categories Changes"
                                  >
                                    <HiArrowPath size={28} color="#5458AF" />
                                  </button> */}

                                </div>

                              </div>
                            </div>
                          </div>
                        </StickyCardBody>

                        {/* PaperFilterLayout - Full Width Below Sticky Header */}
                        <div className="col-md-12 px-0 mb-3 staff-filters-wrapper">
                          <div className="card">
                            <PaperFilterLayout
                              userType={"DEOP"}
                              onFilterChange={this.handleFilterChange}
                              filterKeys={EMPLOYEE_FILTERS.DEOP.PaperMapping}
                              isShowExamStatus={false}
                            />
                          </div>
                        </div>

                        {(addingExamsLoading || this.state.isLoading || deletingPapersLoading) ? (
                          <PageSpinner id="show" text="Loading, Please wait!" />
                        ) : (
                          <div>
                            {/* Commented out MUI Table - Using Card Layout */}
                            {/* <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              className="thead"
                              onClick={() => this.handleSortChange("assessment_id")}
                            >
                              Paper Code
                              {this.state.sortColumn === "assessment_id" && (
                                <span>
                                  {this.state.sortDirection === "asc" ? (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                  ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                  )}
                                </span>
                              )}
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              className="thead"
                              onClick={() => this.handleSortChange("title")}
                            >
                              Paper Title
                              {this.state.sortColumn === "title" && (
                                <span>
                                  {this.state.sortDirection === "asc" ? (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                  ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                  )}
                                </span>
                              )}
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              className="thead"
                              onClick={() => this.handleSortChange("assessment_state")}
                            >
                              Paper Status
                              {this.state.sortColumn === "assessment_state" && (
                                <span>
                                  {this.state.sortDirection === "asc" ? (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                  ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                  )}
                                </span>
                              )}
                            </TableCell>
                            <TableCell className="thead">
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {AssessmentList?.map((assessment) => (
                            <TableRow key={assessment.assessment_id}>
                              <TableCell className="tData"> {"ASMNT" + assessment.assessment_id}</TableCell>
                              <TableCell className="tData">
                                {assessment.title}
                                <div className="d-flex align-items-center" style={{ gap: '1.5rem' }}>
                                  {addedPapers.includes(assessment.assessment_id) && (
                                    <span className="text-success" style={{ fontSize: '0.75rem' }}>
                                      Added ✔
                                    </span>
                                  )}
                                  {this.getCreditCategory(
                                    assessment.grade_id, 
                                    assessment.subject_id,
                                    assessment.language_id,
                                    assessment.exam_category_id
                                  ) === true && (
                                    <span className="text-primary" style={{ fontSize: '0.75rem' }}>
                                      Existing Credit Category ✔
                                    </span>
                                  )}
                                </div>
                              </TableCell>
                              <TableCell className="tData">
                                <div className={this.getColor(assessment.assessment_state)}>
                                  {assessment.assessment_state}
                                </div>
                              </TableCell>
                              <TableCell className="tData">
                                <Button
                                  onClick={(e) => this.handleViewClick(e, assessment)}
                                  className="btn btn-icon btn-primary btn-sm m-1 view-assement-btn flaticon-eye-icon"
                                  title="View Paper Details"
                                />
                                {!addedPapers.includes(assessment.assessment_id) && this.getCreditCategory(
                                    assessment.grade_id, 
                                    assessment.subject_id,
                                    assessment.language_id,
                                    assessment.exam_category_id
                                  ) === true && (
                                  <Button
                                    onClick={(e) => this.handleAddExams(e, assessment.assessment_id)}
                                    className="btn btn-icon btn-primary btn-success btn-sm m-1"
                                    title="Add to Available Papers for Enrollment"
                                  >
                                    <i className="fas fa-plus" />
                                  </Button>
                                )}
                                {addedPapers.includes(assessment.assessment_id) && this.getCreditCategory(
                                    assessment.grade_id, 
                                    assessment.subject_id,
                                    assessment.language_id,
                                    assessment.exam_category_id
                                  ) === true && (
                                    <Button
                                      onClick={(e) => this.handleRemove(e, assessment.assessment_id)}
                                      className="btn btn-icon btn-primary btn-danger btn-sm m-1"
                                      title="Remove from Available Papers before Enrollment"
                                    >
                                      <i className="fas fa-times" />
                                    </Button>
                                )}
                                {addedPapers.includes(assessment.assessment_id) && 
                                  <Button
                                    onClick={(e) => this.handleEditClick(e, assessment)}
                                    className="btn btn-icon btn-primary btn-sm m-1 view-assement-btn flaticon-edit-icon"
                                    title="Override Paper Details"
                                  />}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table> */}

                            {/* Modern Card-based Layout (using FilterPapers.css for all card styles) */}

                            {AssessmentList?.length > 0 ? (
                              <>
                                <div className="ph-paper-table-wrapper">
                                  <div className="row">
                                    {AssessmentList?.map((assessment) => {
                                      const hasAdded = addedPapers.includes(assessment.assessment_id);
                                      const hasCategory = this.getCreditCategory(
                                        assessment.grade_id,
                                        assessment.subject_id,
                                        assessment.language_id,
                                        assessment.exam_category_id
                                      );
                                      const showCardTooltip = !hasAdded && !hasCategory;

                                      const cardInner = (
                                        <div key={assessment.assessment_id} className="col-12 mb-3">
                                          <div className={`card ph-paper-card${showCardTooltip ? ' no-category-cursor' : ''}`}>
                                            <div className="card-body">
                                              {/* Inner row to create the 4 columns */}
                                              <div className="row align-items-center">

                                                {/* 1. Title Column */}
                                                <div className="col-md-4 ph-paper-title-col">
                                                  <h1 className="ph-paper-title mb-0" style={{ fontSize: '1.1rem', fontFamily: 'Inter, sans-serif' }} title={assessment.title}>
                                                    {assessment.title}
                                                  </h1>
                                                </div>

                                                {/* 2. Paper Code Column */}
                                                <div className="col-md-2 text-muted ph-paper-code" style={{ fontFamily: 'Inter, sans-serif' }}>
                                                  {"ASMNT" + assessment.assessment_id}
                                                </div>

                                                {/* 3. Status Chip Column */}
                                                <div className="col-md-3 d-flex align-items-center ph-paper-status-col">
                                                  <div className={`ph-paper-status label label-lg label-inline ${this.getStatusVariant(assessment.assessment_state)}`}>
                                                    {assessment.assessment_state}
                                                  </div>
                                                  {addedPapers.includes(assessment.assessment_id) && (
                                                    <span className="ml-2 ph-badge-added" style={{
                                                      height: '35px',
                                                      lineHeight: '35px',
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      padding: '0 12px',
                                                      backgroundColor: '#319047',
                                                      color: '#fff',
                                                      fontFamily: 'Inter, sans-serif',
                                                      borderRadius: '5px',
                                                      fontWeight: 500,
                                                      whiteSpace: 'nowrap'
                                                    }}>Added</span>
                                                  )}
                                                </div>

                                                {/* 4. Action Buttons Column */}
                                                <div className="col-md-3 text-right d-flex justify-content-end gap-2 ph-paper-actions">
                                                  <button
                                                    type="button"
                                                    onClick={(e) => this.handleViewClick(e, assessment)}
                                                    className="ph-action-btn ph-view"
                                                    title="View Paper Details"
                                                  >
                                                    <i className="flaticon-eye" />
                                                  </button>

                                                  {!addedPapers.includes(assessment.assessment_id) &&
                                                    this.getCreditCategory(
                                                      assessment.grade_id,
                                                      assessment.subject_id,
                                                      assessment.language_id,
                                                      assessment.exam_category_id
                                                    ) && (
                                                      <button
                                                        type="button"
                                                        onClick={(e) => this.handleAddExams(e, assessment.assessment_id)}
                                                        className="ph-action-btn ph-add"
                                                        title="Add to Available Papers"
                                                      >
                                                        <i className="fas fa-plus" />
                                                      </button>
                                                    )}

                                                  {!addedPapers.includes(assessment.assessment_id) &&
                                                    !this.getCreditCategory(
                                                      assessment.grade_id,
                                                      assessment.subject_id,
                                                      assessment.language_id,
                                                      assessment.exam_category_id
                                                    ) && (
                                                      <button
                                                        type="button"
                                                        disabled
                                                        className="ph-action-btn ph-add"
                                                        title="Add to Available Papers"
                                                        style={{ opacity: 0.2, cursor: 'not-allowed' }}
                                                      >
                                                        <i className="fas fa-plus" />
                                                      </button>
                                                    )}

                                                  {!addedPapers.includes(assessment.assessment_id) && (
                                                    <>
                                                      <button
                                                        type="button"
                                                        disabled
                                                        className="ph-action-btn ph-remove"
                                                        style={{ opacity: 0.2, cursor: 'not-allowed' }}
                                                        title="Remove Paper"
                                                      >
                                                        <i className="fas fa-times" />
                                                      </button>
                                                      <button
                                                        type="button"
                                                        disabled
                                                        className="ph-action-btn ph-edit"
                                                        style={{ opacity: 0.2, cursor: 'not-allowed' }}
                                                        title="Override Details"
                                                      >
                                                        <i className="flaticon-edit" />
                                                      </button>
                                                    </>
                                                  )}

                                                  {addedPapers.includes(assessment.assessment_id) && (
                                                    <>
                                                      <button
                                                        type="button"
                                                        disabled
                                                        className="ph-action-btn ph-add"
                                                        title="Paper Already Added"
                                                        style={{ opacity: 0.2, cursor: 'not-allowed' }}
                                                      >
                                                        <i className="fas fa-plus" />
                                                      </button>
                                                      <button
                                                        type="button"
                                                        onClick={(e) => this.handleRemove(e, assessment.assessment_id)}
                                                        className="ph-action-btn ph-remove"
                                                        title="Remove Paper"
                                                      >
                                                        <i className="fas fa-times" />
                                                      </button>
                                                      <button
                                                        type="button"
                                                        onClick={(e) => this.handleEditClick(e, assessment)}
                                                        className="ph-action-btn ph-edit"
                                                        title="Override Details"
                                                      >
                                                        <i className="flaticon-edit" />
                                                      </button>
                                                    </>
                                                  )}
                                                </div>
                                                {/* End of columns */}

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );

                                      return showCardTooltip ? (
                                        <Tooltip
                                          title="Please configure a credit category first to add this paper."
                                          placement="top"
                                          arrow
                                          classes={{ tooltip: 'ph-custom-tooltip' }}
                                        >
                                          {cardInner}
                                        </Tooltip>
                                      ) : (
                                        cardInner
                                      );
                                    })}
                                  </div>
                                </div>
                                <MaterialCustomTablePagination
                                  totalCount={parseInt(totalAssessments)}
                                  currentPage={currentPage}
                                  limit={limit}
                                  handlePageChange={this.handlePageChange}
                                  handleRowsPerPageChange={this.handleRowsPerPageChange}
                                  handlePageOffsetChange={this.handlePageOffsetChange}
                                  rowsPerPageOptions={[5, 10, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                                  offset={offset}
                                />
                              </>
                            ) : (
                              <div className="no-papers-container">
                                <div className="no-papers-inner">
                                  <i className="fas fa-inbox no-papers-icon"></i>
                                  <span className="no-papers-text">No Papers Available</span>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>

            </Card>
          </ContentWrapper>
          <PaperOverrideDrawer
            show={this.state.showOverrideModal}
            onHide={() => this.toggleOverRideCreditCategoryDetailModal()}
            credit_purchase_flag={this.state.credit_purchase_flag}
            amount_purchase_flag={this.state.amount_purchase_flag}
            override_credit={this.state.override_credit}
            override_amount={this.state.override_amount}
            no_of_credits={this.state.no_of_credits}
            no_of_credits_error={this.state.no_of_credits_error}
            price={this.state.price}
            price_error={this.state.price_error}
            price_currency_type_id={this.state.price_currency_type_id}
            allCurrencyTypes={this.state.allCurrencyTypes}
            disabled={this.state.disabled}
            validator={this.validator}
            handleChange={this.handleChange}
            handleChangeCurrencyType={this.handleChangeCurrencyType}
            handleSubmit={this.handleSubmit}
            setDrawerState={(nextState) => this.setState(nextState)}
          />
        </div>
      </>
    );
  }
}
